import { jsx as _jsx } from "react/jsx-runtime";
import { ProductStub } from '../ProductStub';
/** Uptime Alert Templates — Wave 1 target (mirrors the SSL page). */
export function AlertTemplatesPage() {
    return (_jsx(ProductStub, { title: "Alert templates", blurb: "Edit the messages sent on DOWN, UP (recovery), and incident events across email, SMS, and chat. DB-backed templates keyed by alert type with live preview and a send-test button. Ships in Wave 1." }));
}
